module.exports = __webpack_public_path__ + "assets/e1ac2bdca7e06de85e014723363a0968.mp3";